import * as React from "react";
import styled from "styled-components";
import SearchButton from "../button/search/search";
import NavigationDropdown from "./navigation-dropdown";
import NavigationLink from "./navigation-link";

const NavigatationRoot = styled.nav`
  display: none;
  @media (min-width: 1265px) {
    display: block;
  }
`;

const NavigationList = styled.ol`
  display: flex;
  align-items: center;
  list-style-type: none;
  gap: 20px;
`;

function Navigation(props) {
  const { menuItems } = props;

  return (
    <NavigatationRoot data-component-name="navigation">
      <NavigationList>
        {menuItems.map((item) => (
          <li key={item.text}>
            {item.url !== undefined ? (
              <NavigationLink item={item} />
            ) : (
              <NavigationDropdown item={item} />
            )}
          </li>
        ))}
        <li>
          <SearchButton />
        </li>
      </NavigationList>
    </NavigatationRoot>
  );
}

export default Navigation;
